/* globals Forms */

window['settings#edit'] = () => {
  Forms.initMinicolors()
}
